/*
 * @Author: Dzy
 * @Date: 2022-07-18 12:09:17
 * @LastEditors: Dzy
 * @LastEditTime: 2022-10-14 13:23:07
 * @Description: 平台字典类数据缓存：民族、学校、学级、班级
 */
import { defineStore } from 'pinia'

export const useDictionaryStore = defineStore('dicBusi', {
  state: () => {
    return {
      nation: [],
      orgDetail: [],
      grades: [],
      classes: [],
      academicYearList: []
    }
  },
  actions: {
    update_nation(data) {
      this.nation = data
    },
    update_orgDetail(data) {
      this.orgDetail = data
    },
    update_grades(data) {
      this.grades = data
    },
    update_classes(data) {
      this.classes = data
    },
    update_academicYearList(data) {
      this.academicYearList = data
    }
  },
  // 所有数据持久化 插件其他配置
  persist: {
    // 修改为 sessionStorage，默认为 localStorage
    storage: window.sessionStorage
  }
})
